import { createStore } from "redux";

export const actions = {
  OpenModal: function (component) {
    return { type: "SHOW_POPUP", payload: component };
  },
  CloseModal: function () {
    return { type: "HIDE_POPUP" };
  }
};

const initialState = {
  Component: null,
  isOpen: false
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case "SHOW_POPUP":
      return {
        ...state,
        isOpen: true,
        Component: action.payload
      };
    case "HIDE_POPUP":
      return {
        ...state,
        isOpen: false,
        Component: null
      };
    default:
      return state;
  }
};

export const store = createStore(reducer);
